import moment from 'moment-timezone';

// eslint-disable-next-line import/prefer-default-export
export function timestamp(timestamp) {
    return `${moment
        .utc(timestamp)
        .tz('America/Chicago')
        .format('MMM D, YYYY h:mm A')} (CT)`;
}
